module.exports = __webpack_public_path__ + "img/user_icon.0d5dbdba.png";